import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GrupoImportadorService } from '../grupo-importador-service/grupo.importador.service';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-grupo-importador-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./grupo-importador-lista.component.css']
})
export class GrupoImportadorListaComponent
  extends ListaBase
  implements OnInit {
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;

  constructor(service: GrupoImportadorService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 5;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna('descricao', 'parametros.grupoImportador.descricao')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.descricao;
  }

}
